export const DEFAULT_LIST_DISPLAY_COUNT = 10;
export const PRESS_RELEASE_LIST_DISPLAY_COUNT = 12;
export const PRESS_RELEASE_HISTORY_LIST_DISPLAY_COUNT = 20;
export const CUSTOM_MEDIA_LIST_DISPLAY_COUNT = 20;
